import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { getAllProfiles } from "../services/adminService";
import { axiosLogin } from "../services/loginService";
import { deleteProfile } from "../services/adminService";
import { Link } from "react-router-dom";
import NavigationBar from "../NavigationBar";
//A page where the admin fetches all the users from the database and they can edit/remove them.

//Integrate so that only the admin is allowed to access it. --> uType=3
const AdminPage = () => {
    const history = useHistory();
    const[admin, setAdmin] = useState('')

    useEffect( () =>{
        axiosLogin().
            then(response => {
                if(response.data.uType=="3")
                    setAdmin(response.data)
                else
                {
                    alert("You need admin rights to access this page!!");
                    redirectToHome()
                }
            }
                      
            ).catch((e) => {
                alert("Login before accessing the page!");
                history.push("/home")
            });
        }, []);
        
  const [users, setUsers] = useState([]);
  
  const redirectToHome = () => history.push('/home')


  useEffect(() =>
    getAllProfiles()
      .then(users => setUsers(users))
      .catch(e => console.log(e)),[]
    );

    const deleteMovie = (user) =>{
        //console.log(user)
      deleteProfile(user)
        .then(() => setUsers(
          users.filter(u => u !== user)));
        }

  //Add logic for edit profile if extra time.   
  return(
    <>
    <div className="row">
        <div className="col-2"></div>
      <div className="col-8"> 
            <h2>Website Users</h2>
            <ul className="list-group">
                {
                users.map(user =>
                    <li key={user._id}
                        className="list-group-item">
                    <Link  to={{
                            pathname: "/profile/admin/editProfile",
                            state: { ...user}
                        }}><button
                        className="btn btn-warning float-end ms-2" 
                        disabled={user._id == admin._id}>
                        Edit
                    </button>
                    </Link>
                    <button
                        className="btn btn-danger float-end"
                        onClick={() => deleteMovie(user)}  disabled={user._id == admin._id}>
                        Delete
                    </button>
                        <b>{user.name}</b>
                        <br/>
                        @{user.userId}
                    </li>
                )
                }
            </ul>
        </div>
    </div>
    </>
  )
};

export default AdminPage;